import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { SegmentType } from '@goldcast/player-config/src/types/Segment/Type';
import { remotionPlayerStateStore } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/store/remotionPlayerState';
import { getSegmentAtCurrentFrame } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/timeUtils';

export const getLayoutChangeAtCurrentFrame = (clip: Clip) => {
  const currentClipMetadata = clip.asset_metadata;
  const playerConfig = currentClipMetadata.player_config;

  if (playerConfig) {
    const currentSegment = getSegmentAtCurrentFrame(remotionPlayerStateStore.getSnapshot()?.currentTime || 0, clip);
    if (!currentSegment || currentSegment.type !== SegmentType.COMPOSITE) {
      return;
    }
    const currentSegmentFrame = remotionPlayerStateStore.getSnapshot()?.currentTime || 0 - currentSegment.fromFrame;

    const layoutChanges = currentSegment.layoutChanges;

    return layoutChanges.find(
      layoutChange => layoutChange.fromFrame <= currentSegmentFrame && layoutChange.toFrame > currentSegmentFrame
    );
  }

  return;
};
